import API from './jsonapi-constants'

import TEXT from './aimeos-text-constants'
import BASKET from './aimeos-basket-constants'
import MEDIA from './aimeos-media-constants'
import META from './aimeos-meta-constants'
import ATTRIBUTE from './aimeos-attribute-constants'
import PRODUCT_PROPERTY from './aimeos-product-property-constants'
import CATEGORY from './aimeos-category-constants'
import PRICE from './aimeos-price-constants'
import BASKET_ADDRESS from './aimeos-basket-address-constants'
import SERVICE from './aimeos-service-constants.js'
import BASKET_PRODUCT from './aimeos-order-product-constants'

export default {
  TEXT,
  BASKET,
  MEDIA,
  META,
  ATTRIBUTE,
  PRODUCT_PROPERTY,
  CATEGORY,
  PRICE,
  BASKET_ADDRESS,
  SERVICE,
  BASKET_PRODUCT,
  TYPE: {
    PRICE: 'price',
    TEXT: 'text',
    ATTRIBUTE: 'attribute',
    MEDIA: 'media',
    PRODUCT: 'product',
    PRODUCT_PROPERTY: 'product/property',
    CUSTOMER_ADDRESS: 'customer/address',
    CUSTOMER_GROUP: 'customer/group',
    BASKET_ADDRESS: 'basket/address',
    BASKET_PRODUCT: 'basket/product',
    BASKET_SERVICE: 'basket/service',
    SPAREPARTS: 'spareparts',
    CATALOG: 'catalog',
  },
  PRODUCTS: {
    ATTRIBUTE: {
      ID: 'product.id',
      TYPE: 'product.type',
      CODE: 'product.code',
      LABEL: 'product.label',
      STATUS: 'product.status',
      DATESTART: 'product.datestart',
      DATEEND: 'product.dateend',
      CONFIG: 'product.config',
      TARGET: 'product.target',
      CTIME: 'product.ctime',
    },
    RELATIONSHIP: {
      ATTRIBUTES: 'attributes',
      ATTRIBUTE: {
        ID: 'product.lists.id',
        DOMAIN: 'product.lists.domain',
        REFID: 'product.lists.refid',
        DATESTART: 'product.lists.datestart',
        DATEEND: 'product.lists.dateend',
        CONFIG: 'product.lists.config',
        POSITION: 'product.lists.position',
        STATUS: 'product.lists.status',
        TYPE: 'product.lists.type',
      },
      CONFIG: {
        ZZCA: 'zzca',
        DISCOUNT: 'zzca_discount',
      },
    },
    TYPE: {
      SELECT: 'select',
      DEFAULT: 'default',
      BOUGHT_TOGETHER: 'bought-together',
    },
  },
  ORDER: {
    ATTRIBUTE: {
      ORDER_BASEID: 'order.baseid',
    },
    PATHS: {
      LINKS: [API.DATA, API.LINKS],
    },
  },
  LINK: {
    BASKETPRODUCT: 'basket/product',
  },
}
